import { reactQueryAuth } from '@/features/auth/lib/react-query-auth';

export const { useLogout } = reactQueryAuth;
